module.exports = function() {
    $('.careers-search-result-apply-button').click(function() {
        var requisitionId = $(this).data('requisitionId');

        ICF.Modules.Analytics.TrackGoal('Apply Button Click', requisitionId);
    });
};